import styled from "styled-components";

export const PricingPageWrapper = styled.div`
  padding: 40px 60px;

  .ant-card{
    border: 1px solid #e2e8f0;
    border-radius: 7px;
    background-color: #ffffff !important;
  }
  .ant-card-body{
   height: 100%;
   padding: 20px !important;
  }
`;

export const MainHeading = styled.div`
  font-size: 46px;
  color: #020817;;
  padding-top: 90px;
  text-align: center;
`;
export const SubHeading = styled.div`
  font-size: 21px;
  color: #374151;
  width: 55%;
  text-align: center;
`;